import gql from 'graphql-tag';

export const UPLOAD_LMI_PROOF_DOC = gql`
  mutation UploadLmiProofDoc($input: LMIProofDocUploadInput!) {
    uploadLMIProofDoc(input: $input) {
      id
    }
  }
`;

export const uploadLmiProofDocMock = {
  uploadLMIProofDoc: {
    id: 1,
  },
};
